import { __assign, __rest } from "tslib";
import * as React from "react";
import { DateIcon } from "tombac-icons";
import Input from "../Input";
var DatePickerInput = React.forwardRef(function (_a, ref) {
    var inputProps = _a.inputProps, datePickerProps = __rest(_a, ["inputProps"]);
    return (React.createElement(Input, __assign({ icon: React.createElement(DateIcon, null) }, datePickerProps, { readOnly: true }, inputProps, { ref: ref })));
});
DatePickerInput.displayName = "DatePickerInput";
export default DatePickerInput;
